import React, { useEffect, useState } from "react";
import EnterpriseConnectivityViews from "../../views/wirelineEnterpriseConnectivity";
import { useDispatch, useSelector } from "react-redux";
import DashboardFilterForSmbAndFiber from "../../components/dashboardFilterForSmbAndFiber/index";
import { filterNames } from "../../utils/constants";
import Spinner from "../../components/presentationals/Spinner";
import CustomLandingBody from "../../components/customLandingBody";
import {
  triggerIsDashboardAccessible,
  setSelectedData,
  fetchWirelineEnterprisePerf,
  fetchNewAcq,
  fetchUpgradeByProduct,
  fetchNewAcqCsv,
  fetchUpgradeCsv,
  hideAlertEd1,
  fetchShowAlertEd1,
  resetEd1,
  fetchTimestampEd2,
  toggleDateAlert,
  toggleErrorAlert,
  triggerDashboardAudit,
} from "../../redux/actions";
import {
  triggerShowHeader,
  unsetPayoutDashboard,
} from "../../redux/actions/action";
import { csvFilter } from "../../utils/common/csvMappings/ed1AndEd2Csv";
import { ExportToCsv } from "export-to-csv";
import config from "../../utils/config";
import { camelize, isEmptyObject } from "../../utils/common";

const EnterpriseConnectivity = () => {
  const dispatch = useDispatch();
  const {
    getAllAPI,
    tilesData,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
  } = useSelector((state) => state.homeReducer);

  const { dashboardAccessibility } = useSelector(
    (state) => state?.dashboardAccessibilityReducer
  );

  const {
    ed1FilterObj,
    selectedData,
    wirelineEntPerf,
    newAcq,
    upgradeByProduct,
    timestamp,
  } = useSelector((state) => state.Ed1AndEd2Reducer);

  const [showAlert, setShowAlert] = useState(null);
  const dashboardName = "WireLine Enterprise Connectivity";
  let ed2Modules = getAllAPI?.data?.content?.filter(
    (row) => row.moduleName.toLowerCase() === filterNames.ed2.toLowerCase()
  )[0];

  let ed2Tiles = ed2Modules?.modSecMasterTxDtos[0]?.secTilesMasterTxDtos;

  const changeHandler = (type, value) => {
    if (type === "Partner Name") {
      dispatch(
        setSelectedData({
          ...selectedData,
          [type]: value,
        })
      );
    } else if (type === "State") {
      dispatch(
        setSelectedData({
          ...selectedData,
          [type]: value,
          "Partner Name": "",
        })
      );
    } else {
      dispatch(
        setSelectedData({
          [type]: value,
          State: "",
          "Partner Name": "",
        })
      );
    }
  };

  const runButtonClickHandler = () => {
    dispatch(resetEd1());
    fetchWirelineEnterprisePerfApi();
    fetchNewAcqApi();
    fetchUpgradeByProductApi();
  };

  const fetchWirelineEnterprisePerfApi = () => {
    const obj = {
      headers: {
        url: ed2Tiles?.filter(
          (row) => row?.tileName === filterNames.enterprisePerf
        )[0].tileEndPointUrl,
      },
      params: {
        fromDate: headerSelectedDateFrom, //'10-AUG-2023',
        toDate: headerSelectedDateTo, //'12-AUG-2023',
        userId: ![filterNames.End, filterNames.JBA, filterNames.JBAP].includes(
          filterValue.partnerName
        )
          ? selectedData["Partner Name"]?.partnerName?.split(" - ")[2]
          : filterValue.orgId,
      },
    };
    if (obj.headers.url) dispatch(fetchWirelineEnterprisePerf(obj));
  };

  const fetchNewAcqApi = () => {
    const obj = {
      headers: {
        url: ed2Tiles?.filter((row) => row?.tileName === filterNames.acqPerf)[0]
          .tileEndPointUrl,
      },
      params: {
        fromDate: headerSelectedDateFrom, //'10-AUG-2023',
        toDate: headerSelectedDateTo, //'12-AUG-2023',
        userId: ![filterNames.End, filterNames.JBA, filterNames.JBAP].includes(
          filterValue.partnerName
        )
          ? selectedData["Partner Name"]?.partnerName?.split(" - ")[2]
          : filterValue.orgId,
      },
    };
    if (obj.headers.url) dispatch(fetchNewAcq(obj));
  };

  const fetchUpgradeByProductApi = () => {
    const obj = {
      headers: {
        url: ed2Tiles?.filter(
          (row) => row?.tileName === filterNames.upgradeByProduct
        )[0].tileEndPointUrl,
      },
      params: {
        fromDate: headerSelectedDateFrom, //'10-AUG-2023',
        toDate: headerSelectedDateTo, //'12-AUG-2023',
        userId: ![filterNames.End, filterNames.JBA, filterNames.JBAP].includes(
          filterValue.partnerName
        )
          ? selectedData["Partner Name"]?.partnerName?.split(" - ")[2]
          : filterValue.orgId,
      },
    };
    if (obj.headers.url) dispatch(fetchUpgradeByProduct(obj));
  };

  const sendAudit = (viewName) => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "download",
        dashboard: dashboardName,
        empId: filterValue?.orgId?.length
          ? filterValue?.orgId
          : filterValue?.agentId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: viewName,
      },
    };
    triggerDashboardAudit(obj);
  };

  const fetchNewAcqCsvApi = (tileName) => {
    sendAudit(tileName);
    const dateDiff =
      (new Date(headerSelectedDateTo) - new Date(headerSelectedDateFrom)) /
      (1000 * 60 * 60 * 24);

    if (dateDiff > 6) {
      dispatch(toggleDateAlert());
      setTimeout(() => {
        dispatch(toggleDateAlert());
      }, 5000);
    } else {
      const obj = {
        headers: {
          url: ed2Tiles?.filter(
            (row) => row?.tileName === filterNames.acqPerf
          )[0].csvEndPointUrl,
          datasource: "SAF",
        },
        params: {
          fromDate: headerSelectedDateFrom, //'10-AUG-2023',
          toDate: headerSelectedDateTo, //'12-AUG-2023',
          userId: ![
            filterNames.End,
            filterNames.JBA,
            filterNames.JBAP,
          ].includes(filterValue.partnerName)
            ? selectedData["Partner Name"]?.partnerName?.split(" - ")[2]
            : filterValue.orgId,
        },
      };
      let options = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: false,
        title: "Data",
        useTextFile: false,
        filename: `New_Acq`,
        useBom: true,
        useKeysAsHeaders: true,
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      };

      let csvExporter = new ExportToCsv(options);
      dispatch(
        fetchNewAcqCsv(
          obj,
          (res) => {
            if (res?.content?.length) {
              // console.log(params.dist)
              let csvData;
              csvData = csvFilter(res.content, "NewAcq");
              csvExporter.generateCsv(csvData);
            } else {
              dispatch(fetchShowAlertEd1());
              setTimeout(() => {
                dispatch(hideAlertEd1());
              }, 5000);
            }
          },
          (err) => {
            dispatch(toggleErrorAlert());
            setTimeout(() => {
              dispatch(toggleErrorAlert());
            }, 5000);
          }
        )
      );
    }
  };

  const fetchUpgradeCsvApi = (tileName) => {
    sendAudit(tileName);
    const dateDiff =
      (new Date(headerSelectedDateTo) - new Date(headerSelectedDateFrom)) /
      (1000 * 60 * 60 * 24);

    if (dateDiff > 6) {
      dispatch(toggleDateAlert());
      setTimeout(() => {
        dispatch(toggleDateAlert());
      }, 5000);
    } else {
      const obj = {
        headers: {
          url: ed2Tiles?.filter(
            (row) => row?.tileName === filterNames.upgradeByProduct
          )[0].csvEndPointUrl,
          datasource: "MACD",
        },
        params: {
          fromDate: headerSelectedDateFrom, //'10-AUG-2023',
          toDate: headerSelectedDateTo, //'12-AUG-2023',
          userId: ![
            filterNames.End,
            filterNames.JBA,
            filterNames.JBAP,
          ].includes(filterValue.partnerName)
            ? selectedData["Partner Name"]?.partnerName?.split(" - ")[2]
            : filterValue.orgId,
        },
      };
      let options = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: false,
        title: "Data",
        useTextFile: false,
        filename: `Upgrade_by_product`,
        useBom: true,
        useKeysAsHeaders: true,
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      };

      let csvExporter = new ExportToCsv(options);
      dispatch(
        fetchUpgradeCsv(
          obj,
          (res) => {
            if (res?.content?.length) {
              // console.log(params.dist)
              let csvData;
              csvData = csvFilter(res.content, "upgrade");
              csvExporter.generateCsv(csvData);
            } else {
              dispatch(fetchShowAlertEd1());
              setTimeout(() => {
                dispatch(hideAlertEd1());
              }, 5000);
            }
          },
          (err) => {
            dispatch(toggleErrorAlert());
            setTimeout(() => {
              dispatch(toggleErrorAlert());
            }, 5000);
          }
        )
      );
    }
  };

  const fetchTimestampApi = () => {
    const obj = {
      headers: {
        url: "/get-Updated-timestamp",
      },
    };
    dispatch(fetchTimestampEd2(obj));
  };

  useEffect(() => {
    const unsetPayoutDashboardForCalender = () => {
      return dispatch(unsetPayoutDashboard());
    };
    unsetPayoutDashboardForCalender();
  }, []);

  useEffect(() => {
    // fetchWirelineAchApi();
    const showHeader = () => {
      return dispatch(triggerShowHeader(true));
    };

    //check if isTestingActive is true, then send api call for triggerIsDashboardAccessible
    let isTestingActive = tilesData?.data?.content?.filter(
      (obj) => obj.moduleName.toLowerCase() === filterNames.ed2.toLowerCase()
    )[0].isTestingActive;

    //if it is true, then check if this logged in user has access to this dashboard
    if (isTestingActive) {
      //to check if the response for this dashboard api call is already cached in redux
      let isExistingDashboard = dashboardAccessibility?.data?.filter(
        (currentDashboard) => currentDashboard.dashboard === dashboardName
      );

      //if dashboard accessibility is already cached and accessEnabled is false, means directly show alert without sending api call again
      if (
        isExistingDashboard.length > 0 &&
        !isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        // load dashboardcard home component and show alert
        return setShowAlert(true);
      }

      // if dashboard accessibility is cached and accessEnabled is true, do not send api call, do not show alert BUT SHOW DASHBOARD NORMALLY
      else if (
        isExistingDashboard.length > 0 &&
        isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        setShowAlert(false);
        showHeader();
      }

      //if dashboard accessibility is not cached already then send api call for this dashboard
      else {
        const data = {
          baseParameter: {
            name: dashboardName,
            userType: filterValue.site,
          },
          domainId:
            filterValue.orgId !== "" ? filterValue.orgId : filterValue?.agentId,
        };

        const obj = {
          headers: {
            "Content-Type": "application/json",
            url: "get-dashboard-user-role-mapping",
          },
          params: data,
          extraData: "get-dashboard-user-role-mapping",
        };

        return dispatch(
          triggerIsDashboardAccessible(obj, (res) => {
            //if the response shows access enabled as false, go to home page and show alert
            if (!res.content.accessEnabled) {
              setShowAlert(true);
            } else {
              setShowAlert(false);
              showHeader();
            }
          })
        );
      }
    }

    //if isTestingActive is false, it is open for all users
    else {
      setShowAlert(false);
      showHeader();
    }
  }, [getAllAPI]);

  useEffect(() => {
    if (
      (![filterNames.End, filterNames.JBA, filterNames.JBAP].includes(
        filterValue.partnerName
      ) &&
        !isEmptyObject(selectedData["Partner Name"])) ||
      [filterNames.End, filterNames.JBA, filterNames.JBAP].includes(
        filterValue.partnerName
      )
    ) {
      if (wirelineEntPerf.data === null) fetchWirelineEnterprisePerfApi();
      if (newAcq.data === null) fetchNewAcqApi();
      if (upgradeByProduct.data === null) fetchUpgradeByProductApi();
      if (timestamp.data === null) fetchTimestampApi();
    }
  }, [
    ed1FilterObj,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    getAllAPI,
    selectedData,
    // filterValue
  ]);

  useEffect(() => {
    if (filterValue.partnerName === "Region Head") {
      dispatch(
        setSelectedData({
          ...selectedData,
          Region: config.regionMaps[tilesData?.data?.extraData?.region],
          State:
            config.states[
              config.regionMaps[tilesData?.data?.extraData?.region]
            ][0],
        })
      );
    }
    if (filterValue.partnerName === "STATE HEAD") {
      dispatch(
        setSelectedData({
          ...selectedData,
          State: camelize(tilesData?.data?.extraData?.state),
        })
      );
    }
  }, [getAllAPI]);

  return showAlert === null ? (
    <Spinner />
  ) : showAlert ? (
    <CustomLandingBody showAlert={showAlert} dashboardName={dashboardName} />
  ) : (
    <div className="container-fluid">
      {![filterNames.End, filterNames.JBA, filterNames.JBAP].includes(
        filterValue.partnerName
      ) && (
        <DashboardFilterForSmbAndFiber
          changeHandler={changeHandler}
          runButtonClickHandler={runButtonClickHandler}
          dashboardMenu={config.SmbAndFiberFilterFormConf}
          type={dashboardName}
        />
      )}
      <EnterpriseConnectivityViews
        getAllAPI={getAllAPI}
        ed2Modules={ed2Modules}
        ed2Tiles={ed2Tiles}
        fetchNewAcqCsvApi={fetchNewAcqCsvApi}
        fetchUpgradeCsvApi={fetchUpgradeCsvApi}
      />
    </div>
  );
};

export default EnterpriseConnectivity;
